var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import ReactTooltip from "react-tooltip";
import { uniqueId } from "lodash";
import Icon from "../Icon/Icon";
import "./Help.scss";
export default function Help(props) {
    var helpId = uniqueId("mp-help-");
    var children = props.children, icon = props.icon, className = props.className, _a = props.role, role = _a === void 0 ? "button" : _a, otherProps = __rest(props, ["children", "icon", "className", "role"]);
    return (_jsxs("div", __assign({ className: "mp-help" }, { children: [_jsx("a", __assign({ className: "mp-help-icon-button ".concat(className), "data-tip": children, "data-for": helpId }, otherProps, { children: _jsx(Icon, { icon: icon, title: "Help", role: role }) })), _jsx(ReactTooltip, { className: "mp-help-tooltip", place: "bottom", type: "dark", effect: "solid", event: "click focus", multiline: true, html: true, id: helpId, globalEventOff: "click" })] })));
}
